import {forwardRef, useRef} from "react";
import {PriorityIconWithTitleProp} from "../props";
import {useElementKeyPress} from "@cdx/common";
import Helper from "../Helper";
import {NoneButton} from "./shared";
import {Box, Col, Row, css, DSListTile, DSShortcutKey} from "@cdx/ds";

const priorityHelper = (
  <Helper
    heading={
      <>
        What is priority? <DSShortcutKey size="lg">p</DSShortcutKey>
      </>
    }
  >
    <p>
      Prority, as the name implies, enables you to assign a sense relative importance for the work
      in your backlog.
    </p>
    <p>
      Assigning a priority, especially for work that you expect to start soon, is a sound practice
      you should make a habit of.
    </p>
    <p>
      Note that you can rename the text labels for low, medium and high priority in your project
      settings.
    </p>
  </Helper>
);

export const PrioButton = forwardRef(({prio, onSelect, account, root, ...rest}, ref) => (
  <DSListTile
    onClick={() => onSelect(prio)}
    aria-label={`set to priority ${prio}`}
    ref={ref}
    style={{flex: "1px 1 0"}}
    {...rest}
  >
    <Col align="center" sp="4px">
      <PriorityIconWithTitleProp priority={prio} root={root} size={24} />
      <Box>{account.priorityLabels[prio]}</Box>
    </Col>
  </DSListTile>
));

export const PriorityPicker = (props) => {
  const {value, onChange, account, autoFocus, root} = props;
  const aButtonRef = useRef();
  const bButtonRef = useRef();
  const cButtonRef = useRef();
  const buttonRefs = {
    c: cButtonRef,
    b: bButtonRef,
    a: aButtonRef,
  };

  const handlers = useElementKeyPress({
    1: {
      fn: () => {
        cButtonRef.current.focus();
        onChange({priority: "c"});
      },
    },
    2: {
      fn: () => {
        bButtonRef.current.focus();
        onChange({priority: "b"});
      },
    },
    3: {
      fn: () => {
        aButtonRef.current.focus();
        onChange({priority: "a"});
      },
    },
  });

  return (
    <Col sp="12px" pt="16px" pb="24px">
      <Row align="center" sp="8px">
        <Box as="h3" size={12} bold color="primary" textTransform="uppercase">
          Priority
        </Box>
        {priorityHelper}
        <NoneButton
          onClick={() => onChange({priority: null})}
          active={value === null}
          className={css({ml: "auto"})}
        />
      </Row>
      <Row sp="4px">
        {["c", "b", "a"].map((val) => (
          <PrioButton
            key={val}
            prio={val}
            onSelect={(priority) => onChange({priority})}
            ref={buttonRefs[val]}
            account={account}
            active={value === val}
            autoFocus={val === "c" && autoFocus}
            root={root}
            {...handlers}
          />
        ))}
      </Row>
    </Col>
  );
};
